import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import { updateOrgPreference } from "../../../store/actions";

const ChangeOrgPreference = (props) => {
    const { orgPreferenceDetails, userId } = props;
    const [formFields, setFormFields] = useState();
    const [errors, setError] = useState();

    useEffect(() => {
        if (orgPreferenceDetails) {
            setFormFields({ ...orgPreferenceDetails })
        }
        //--------------------Key-Listener----------------------
        const handleKeyPress = (e) => {
            if (e.key === "Escape") {
                props.handleClose();
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [])

    const handleClearLogo = () => {
        setFormFields({
            ...formFields,
            applicationLogo: null,
        })
    }
    const handleInputChange = (event) => {
        const { name } = event.target;
        const input = event.target;
        const value = input.type === 'checkbox' ? input.checked : input.value;
        setFormFields({
            ...formFields,
            [name]: value
        })
    }

    const handleLogoChange = (event) => {
        const filedata = event.target.files[0];
        const { name } = event.target;

        if (filedata) {
            const img = new Image();
            const reader = new FileReader();
            const imageSize = filedata.size;
            const imageSizeInKB = imageSize / 1024;

            reader.onloadend = () => {
                img.src = reader.result;
                img.onload = () => {
                    if (imageSizeInKB > 200) {
                        setError({
                            ...errors,
                            applicationLogo: "Image size should below 200 kb."
                        });
                    }
                    else if (img.width > 900 || img.height > 350) {
                        setError({
                            ...errors,
                            applicationLogo: "Image dimensions should not exceed 900px in width and 350px in height."
                        });
                    }
                    else {
                        setFormFields({
                            ...formFields,
                            [name]: reader.result
                        });
                        setError({
                            ...errors,
                            applicationLogo: null,
                        });
                    }
                };

            };
            reader.readAsDataURL(filedata);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const { applicationLogo } = errors || {};
        let currentErrors = {};

        if (applicationLogo) {
            currentErrors.applicationLogo = applicationLogo;
        }

        if (Object.keys(currentErrors).length === 0) {
            props.updateOrgPreference(formFields, userId);
        }
    }
    return (
        <>
            <Form onSubmit={handleSubmit}>
                <FormGroup>
                    <Label>Application Name</Label>
                    <Input
                        autoFocus
                        name='applicationName'
                        type='text'
                        placeHolder='Enter application name'
                        onChange={handleInputChange}
                        value={formFields && formFields.applicationName}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Application Logo</Label>
                    {formFields && formFields.applicationLogo ?
                        <>
                            <br />
                            <img
                                src={formFields.applicationLogo}
                                alt='logo'
                                style={{
                                    height: "80px",
                                    width: "auto"
                                }}
                            />
                            <Button
                                className='ms-4 px-2 py-0'
                                color='danger'
                                onClick={handleClearLogo}
                            >
                                <i className="mdi mdi-close fs-4 p-0" />
                            </Button>
                        </>
                        : <>
                            <Input
                                name='applicationLogo'
                                type='file'
                                accept="image/png, image/gif, image/jpeg"
                                onChange={handleLogoChange}
                                invalid={errors && errors.applicationLogo}
                            />
                            <FormFeedback>{errors && errors.applicationLogo}</FormFeedback>
                        </>
                    }
                </FormGroup>
                <FormGroup>
                    <Input
                        className="me-2"
                        type="checkbox"
                        name="approveNewCustomer"
                        onChange={handleInputChange}
                        checked={formFields && formFields.approveNewCustomer}
                    />
                    <Label>
                        Approve New Customer?
                    </Label>
                </FormGroup>
                <FormGroup>
                    <Input
                        className="me-2"
                        type="checkbox"
                        name="allowCustomerSelfRegistration"
                        onChange={handleInputChange}
                        checked={formFields && formFields.allowCustomerSelfRegistration}
                    />
                    <Label>
                        Allow Customer Self Registration?
                    </Label>
                </FormGroup>
                <FormGroup>
                    <Input
                        className="me-2"
                        type="checkbox"
                        name="enableUserMailNotification"
                        onChange={handleInputChange}
                        checked={formFields && formFields.enableUserMailNotification}
                    />
                    <Label>
                        Enable Email Notification To Customer?
                    </Label>
                </FormGroup>
                <FormGroup>
                    <Input
                        className="me-2"
                        type="checkbox"
                        name="isReturnApproval"
                        onChange={handleInputChange}
                        checked={formFields && formFields.isReturnApproval}
                    />
                    <Label>
                        Enable Return Device Without Approval?
                    </Label>
                </FormGroup>
                <FormGroup>
                    <Button color="success" type="submit" className="me-2" onClick={handleSubmit}>Submit</Button>
                    <Button color="danger" onClick={props.handleClose}>Cancel</Button>
                </FormGroup>
            </Form>
        </>
    )
}

const mapDispatchToProps = (dispatch) => ({
    updateOrgPreference: (formFields, userId) => dispatch(updateOrgPreference(formFields, userId)),
})
export default connect(null, mapDispatchToProps)(ChangeOrgPreference);
